import { render, staticRenderFns } from "./DownloadPageButton.vue?vue&type=template&id=5acd1f12"
import script from "./DownloadPageButton.vue?vue&type=script&lang=ts"
export * from "./DownloadPageButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports